var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { loading } from '../../../elements/Loading';
import { inject } from 'mobx-react';
import { Card, Col, Container, FormGroup, Label, Row, Input, Tooltip } from 'reactstrap';
import { t, T } from 'helpers/i18n';
import history from '../../../helpers/History';
import { Button, CheckBox, Loading } from '../../../elements';
import CalendarAvailable from '../../../components/CalendarAvailable/CalendarAvailable';
import History from '../../../helpers/History';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { rules, Validation } from '../../../helpers/Validation';
import { objectValues } from '../../../helpers/Utils';
var CollaboratorStretchesFormEdit = /** @class */ (function (_super) {
    __extends(CollaboratorStretchesFormEdit, _super);
    function CollaboratorStretchesFormEdit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            serviceTIN: '',
            editedServiceTINEnabled: false,
            isLoading: false,
            emails: '',
            toottipTIN: false
        };
        _this.handleOnChange = function (name, event) {
            var value = event.target.value;
            var toState = {};
            toState[name] = value;
            _this.setState(toState);
        };
        _this.handleOnClick = function () {
            // compruebo rules
            var emailRules = rules()
                .arrayEmailsComma();
            var TINrules = rules()
                .required();
            var values = {
                emails: _this.state.emails,
                tin: _this.state.serviceTIN
            };
            var schema = {
                emails: emailRules,
                tin: TINrules
            };
            var validation = new Validation(values, schema);
            console.log('validation: ', validation);
            if (!validation.valid) {
                console.log('dentro if !validation.valid');
                _this.setState({ isLoading: false });
                return _this.props.store.UI.newWarning(objectValues(validation.errors).join('\n'));
            }
            _this.setState({ isLoading: true });
            _this.props.store.collaboratorStretchesStore.updateServiceTIN(_this.state.serviceTIN, _this.props.collaboratorStretch.row_id, _this.props.collaboratorStretch.id, _this.props.collaboratorStretch.operator_id, _this.state.emails).then(function (value) {
                _this.setState({ editedServiceTINEnabled: false, isLoading: false });
                _this.props.store.UI.newWarning(T('saved'));
            }).catch(function (error) {
                _this.props.store.UI.newError(T('error:tryAgainLater'));
            });
        };
        return _this;
    }
    CollaboratorStretchesFormEdit.prototype.componentDidMount = function () {
        if (this.props.collaboratorStretch.serviceTIN && !this.state.serviceTIN) {
            this.setState({ serviceTIN: this.props.collaboratorStretch.serviceTIN });
        }
        if (this.props.collaboratorStretch.serviceEmails && !this.state.emails) {
            this.setState({ emails: this.props.collaboratorStretch.serviceEmails });
        }
    };
    CollaboratorStretchesFormEdit.prototype.render = function () {
        var _this = this;
        var collaboratorStretch = this.props.collaboratorStretch;
        var _a = this.state, serviceTIN = _a.serviceTIN, editedServiceTINEnabled = _a.editedServiceTINEnabled, isLoading = _a.isLoading, emails = _a.emails;
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        if (!collaboratorStretch) {
            return React.createElement(Loading, null);
        }
        var disabled = !editedServiceTINEnabled;
        return (React.createElement("div", { className: "pb-5" },
            React.createElement(Container, null,
                React.createElement(Card, { className: "m-3 p-3" },
                    React.createElement(Container, null,
                        React.createElement(Card, { className: "m-3 p-3" },
                            React.createElement(Row, { form: true },
                                React.createElement(Col, null,
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('owner')),
                                        React.createElement(Input, { value: collaboratorStretch.operatorName, disabled: true })))),
                            React.createElement(Row, { form: true },
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('name')),
                                        React.createElement(Input, { value: collaboratorStretch.name, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('businessunit')),
                                        React.createElement(Input, { value: collaboratorStretch.operationLine.businessUnit.name, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('operationLine')),
                                        React.createElement(Input, { value: collaboratorStretch.operationLine.name, disabled: true })))),
                            React.createElement(Row, { form: true },
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('origin')),
                                        React.createElement(Input, { value: collaboratorStretch.origin, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('destination')),
                                        React.createElement(Input, { value: collaboratorStretch.destination, disabled: true, label: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('tax')),
                                        React.createElement(Input, { value: collaboratorStretch.tax.name, disabled: true })))),
                            React.createElement(Row, null,
                                React.createElement(Col, { md: 4, style: { display: 'flex', justifyContent: 'start', alignItems: 'center' } },
                                    React.createElement(CheckBox, { onChange: function () { }, label: T('printPrice'), checked: collaboratorStretch.printPrice })),
                                React.createElement(Col, { md: 4, style: { display: 'flex', justifyContent: 'start', alignItems: 'center' } },
                                    React.createElement(CheckBox, { onChange: function () { }, label: T('tramoHora'), checked: collaboratorStretch.tramoHora })),
                                React.createElement(Col, { md: 4, style: { display: 'flex', justifyContent: 'start', alignItems: 'center' } },
                                    React.createElement(CheckBox, { onChange: function () { }, label: T('hopon'), checked: collaboratorStretch.hoponHopoff }))),
                            collaboratorStretch.tramoHora && React.createElement(Row, null,
                                React.createElement(Col, null,
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('departureTime')),
                                        React.createElement(Input, { type: 'select', multiple: true, disabled: true, style: { height: 27 * collaboratorStretch.horasIda.length, overflowY: 'auto' } }, collaboratorStretch.horasIda.map(function (hora) {
                                            return React.createElement("option", { key: "".concat(hora.hours, ":").concat(hora.minutes) }, "".concat(hora.hours > 9 ? hora.hours : '0' + hora.minutes, ":").concat(hora.minutes > 9 ? hora.minutes : '0' + hora.minutes));
                                        }))))),
                            React.createElement(Row, null,
                                React.createElement(Col, { md: 6, lg: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('timeAdvance')),
                                        React.createElement(Input, { value: collaboratorStretch.timeAdvance, disabled: true }))),
                                React.createElement(Col, { md: 6, lg: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('timeDelay')),
                                        React.createElement(Input, { value: collaboratorStretch.timeDelay, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('timeCancel')),
                                        React.createElement(Input, { value: collaboratorStretch.timeCancel, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('timeExpiration')),
                                        React.createElement(Input, { value: collaboratorStretch.timeExpiration, disabled: true }))),
                                React.createElement(Col, { md: 4 },
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('timeUse')),
                                        React.createElement(Input, { value: collaboratorStretch.timeUse, disabled: true }))))),
                        React.createElement(Card, { className: "m-3 p-3" },
                            React.createElement(Row, { form: true },
                                React.createElement(Col, null,
                                    React.createElement(FormGroup, null,
                                        React.createElement(Tooltip, { target: 'serviceTin', isOpen: this.state.toottipTIN, toggle: function () { _this.setState({ toottipTIN: !_this.state.toottipTIN }); } }, T('tinISTooltip')),
                                        React.createElement(Label, null, T('tinIS')),
                                        React.createElement(Input, { id: 'serviceTin', value: serviceTIN, onChange: function (event) { return _this.handleOnChange('serviceTIN', event); } })),
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, null, T('emails')),
                                        React.createElement(Input, { value: emails, onChange: function (event) { return _this.handleOnChange('emails', event); } })),
                                    React.createElement(FormGroup, null,
                                        React.createElement(Button, { style: { marginBottom: '10px' }, onClick: this.handleOnClick, 
                                            // disabled={disabled}
                                            loading: isLoading }, T('save')))))),
                        React.createElement(Row, { form: true, className: "p-3" },
                            React.createElement(Col, { xl: 8, sm: 12 },
                                React.createElement(Card, { className: "p-3 mb-2" },
                                    React.createElement(Label, null, T('calendarAvailable')),
                                    React.createElement(CalendarAvailable, { stretch: collaboratorStretch, disabledDays: collaboratorStretch.disabledDays, onDateClick: null }))),
                            React.createElement(Col, { xl: 4, sm: 12 }, collaboratorStretch.prices &&
                                React.createElement("div", null,
                                    React.createElement(Card, { className: "p-3 mr-6 ml-6 ml-sm-3" },
                                        React.createElement(Label, null, T('prices')),
                                        React.createElement(Container, null,
                                            React.createElement(Row, null, collaboratorStretch.prices.map(function (price) { return (React.createElement(Col, { md: 4, lg: 6 },
                                                React.createElement(Label, null, price.passengerCategory.name),
                                                React.createElement(Input, { style: { marginBottom: '10px' }, disabled: true, value: price.price }))); })))))),
                            React.createElement(Col, { xl: 4, sm: 12 }, collaboratorStretch.prices &&
                                React.createElement("div", null,
                                    React.createElement(Card, { className: "p-3 mr-6 ml-6 ml-sm-3" },
                                        React.createElement(Label, null, T('pricesNet')),
                                        React.createElement(Container, null,
                                            React.createElement(Row, null, collaboratorStretch.prices.map(function (price) { return (React.createElement(Col, { md: 4, lg: 6 },
                                                React.createElement(Label, null, price.passengerCategory.name),
                                                React.createElement(Input, { style: { marginBottom: '10px' }, disabled: true, value: price.priceNet }))); })))))))))),
            React.createElement(ButtonsBar, null, hasParent && (React.createElement(StyledButton, { onClick: function () { history.goBack(); } }, t('ok'))))));
    };
    CollaboratorStretchesFormEdit = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params ? props.store.collaboratorStretchesStore.read({
                operator_id: Number(props.match.params.operator_id),
                stretch_id: Number(props.match.params.stretch_id)
            })
                .then(function (collaboratorStretch) { return ({ collaboratorStretch: collaboratorStretch }); }) : undefined
        ]; })
    ], CollaboratorStretchesFormEdit);
    return CollaboratorStretchesFormEdit;
}(Component));
export default CollaboratorStretchesFormEdit;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/container/CollaboratorStretchesFormEdit.tsx
// module id = 1599
// module chunks = 0